<template>
  <div>
<ComponentsMfSecuenciaComprobantesFi ref="RefComponentsMfSecuenciaComprobantesFi"  />
  </div>
</template>

<script>
import ComponentsMfSecuenciaComprobantesFi from "@/ModuloFiscal/Mant/SecuenciaComprobantes.vue"
import AutoNumeric from "../../components/AutoNumericNuevo";
import { EventBus } from "../../event-bus";
export default {

  components: {
    AutoNumeric,
    ComponentsMfSecuenciaComprobantesFi
  },
  mounted() {

     var _this = this
        setTimeout(function() {
          _this.$refs.RefComponentsMfSecuenciaComprobantesFi.cargarComponente()
        }, 500)

  },

  created() {

  },

  data() {

    return {

      valid: true,

    }

  },


  methods: {

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.new();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
      }
    },


  }

}
</script>

<style>

</style>